import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Tag, ChevronRight, Calendar, MapPin, ExternalLink, Filter, Search, Percent, Car, Zap, Star } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Specials = () => {
  const [specials, setSpecials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBrand, setSelectedBrand] = useState('All');

  const brands = ['All', 'Toyota', 'Volkswagen', 'Ford', 'BMW', 'Mercedes-Benz', 'Hyundai', 'Kia', 'Suzuki', 'Renault', 'Haval', 'Chery', 'GWM', 'BYD', 'Isuzu'];

  useEffect(() => {
    document.title = 'Car Specials & Deals | AutoSearch SA';
    fetchSpecials();
  }, []);

  const fetchSpecials = async () => {
    // For now, use hardcoded specials since we scrape from multiple sources
    // In the future, this can be enhanced to scrape dealer specials
    const defaultSpecials = [
      {
        id: 1,
        title: "New Suzuki Swift 1.2 GL",
        dealer: "Suzuki SA",
        price: "R219,900",
        monthlyPayment: "R3,995",
        image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=600&q=80",
        brand: "Suzuki",
        location: "Nationwide",
        validUntil: "March 2025",
        featured: true,
        link: "https://www.suzukiauto.co.za"
      },
      {
        id: 2,
        title: "Toyota Starlet 1.5 XS Auto",
        dealer: "Toyota SA",
        price: "R289,900",
        monthlyPayment: "R4,450",
        image: "https://images.unsplash.com/photo-1590362891991-f776e747a588?w=600&q=80",
        brand: "Toyota",
        location: "Nationwide",
        validUntil: "February 2025",
        featured: true,
        link: "https://www.toyota.co.za"
      },
      {
        id: 3,
        title: "Volkswagen Polo Vivo 1.4 Trendline",
        dealer: "Volkswagen SA",
        price: "R279,900",
        monthlyPayment: "R4,295",
        image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=600&q=80",
        brand: "Volkswagen",
        location: "Gauteng",
        validUntil: "February 2025",
        link: "https://www.volkswagen.co.za"
      },
      {
        id: 4,
        title: "Haval Jolion 1.5T City",
        dealer: "Haval SA",
        price: "R399,950",
        monthlyPayment: "R5,995",
        image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=600&q=80",
        brand: "Haval",
        location: "Nationwide",
        validUntil: "March 2025",
        link: "https://www.haval.co.za"
      },
      {
        id: 5,
        title: "Ford Ranger 2.0 Bi-Turbo XLT",
        dealer: "Ford SA",
        price: "R699,900",
        monthlyPayment: "R10,995",
        image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80",
        brand: "Ford",
        location: "Nationwide",
        validUntil: "February 2025",
        link: "https://www.ford.co.za"
      },
      {
        id: 6,
        title: "Hyundai Creta 1.5 Executive",
        dealer: "Hyundai SA",
        price: "R459,900",
        monthlyPayment: "R6,995",
        image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=600&q=80",
        brand: "Hyundai",
        location: "Western Cape",
        validUntil: "March 2025",
        link: "https://www.hyundai.co.za"
      },
      {
        id: 7,
        title: "Chery Tiggo 4 Pro 1.5T Elite",
        dealer: "Chery SA",
        price: "R369,900",
        monthlyPayment: "R5,595",
        image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=600&q=80",
        brand: "Chery",
        location: "Nationwide",
        validUntil: "February 2025",
        featured: true,
        link: "https://www.cherysa.co.za"
      },
      {
        id: 8,
        title: "BYD Atto 3 Extended Range",
        dealer: "BYD SA",
        price: "R749,900",
        monthlyPayment: "R11,495",
        image: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=600&q=80",
        brand: "BYD",
        location: "Gauteng",
        validUntil: "March 2025",
        isElectric: true,
        link: "https://www.byd.com/za"
      },
      {
        id: 9,
        title: "Kia Seltos 1.6 EX",
        dealer: "Kia SA",
        price: "R479,995",
        monthlyPayment: "R7,295",
        image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=600&q=80",
        brand: "Kia",
        location: "Nationwide",
        validUntil: "February 2025",
        link: "https://www.kia.co.za"
      },
      {
        id: 10,
        title: "Renault Kwid 1.0 Climber",
        dealer: "Renault SA",
        price: "R219,900",
        monthlyPayment: "R3,295",
        image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=600&q=80",
        brand: "Renault",
        location: "Nationwide",
        validUntil: "March 2025",
        link: "https://www.renault.co.za"
      },
      {
        id: 11,
        title: "Isuzu D-Max 1.9 LS Double Cab",
        dealer: "Isuzu SA",
        price: "R549,900",
        monthlyPayment: "R8,495",
        image: "https://images.unsplash.com/photo-1559416523-140ddc3d238c?w=600&q=80",
        brand: "Isuzu",
        location: "KwaZulu-Natal",
        validUntil: "February 2025",
        link: "https://www.isuzu.co.za"
      },
      {
        id: 12,
        title: "GWM P-Series 2.0TD LS Double Cab",
        dealer: "GWM SA",
        price: "R499,900",
        monthlyPayment: "R7,695",
        image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80",
        brand: "GWM",
        location: "Nationwide",
        validUntil: "March 2025",
        link: "https://www.gwm.co.za"
      }
    ];

    setSpecials(defaultSpecials);
    setLoading(false);
  };

  const filteredSpecials = specials.filter(special => 
    selectedBrand === 'All' || special.brand === selectedBrand
  );

  const featuredSpecials = filteredSpecials.filter(s => s.featured);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero */}
      <section className="bg-gradient-to-br from-orange-600 via-red-600 to-pink-600 text-white py-12">
        <div className="container">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <Percent className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">Car Specials & Deals</h1>
              <p className="text-orange-100">Latest promotions from SA dealerships</p>
            </div>
          </div>
          <p className="text-lg text-white/90 max-w-2xl">
            Find the best deals on new cars from dealerships across South Africa. Updated regularly with the latest manufacturer promotions.
          </p>
        </div>
      </section>

      {/* Featured Specials */}
      {featuredSpecials.length > 0 && (
        <section className="container py-8">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
            <Star className="w-5 h-5 text-yellow-500" />
            Featured Deals
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuredSpecials.slice(0, 3).map((special) => (
              <a
                key={special.id}
                href={special.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative rounded-2xl overflow-hidden h-64 shadow-lg block"
              >
                <img
                  src={special.image}
                  alt={special.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
                <div className="absolute top-3 right-3">
                  <span className="px-3 py-1 bg-red-600 text-white text-xs font-bold rounded-full">
                    SPECIAL
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-lg font-bold text-white mb-1 group-hover:text-orange-300 transition">
                    {special.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-2xl font-bold text-orange-400">{special.price}</p>
                      <p className="text-sm text-gray-300">or {special.monthlyPayment}/pm</p>
                    </div>
                    <ExternalLink className="w-5 h-5 text-white/70" />
                  </div>
                </div>
              </a>
            ))}
          </div>
        </section>
      )}

      {/* Filters */}
      <section className="container py-4">
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm">
          <div className="flex items-center gap-2 mb-3">
            <Filter className="w-4 h-4 text-gray-500" />
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Filter by Brand:</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {brands.map((brand) => (
              <button
                key={brand}
                onClick={() => setSelectedBrand(brand)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition ${
                  selectedBrand === brand
                    ? 'bg-orange-600 text-white'
                    : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                }`}
              >
                {brand}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Specials Grid */}
      <section className="container py-8">
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredSpecials.map((special) => (
              <a
                key={special.id}
                href={special.link}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition group block"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={special.image}
                    alt={special.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 flex items-center gap-2">
                    <span className="px-2 py-1 bg-orange-600 text-white text-xs font-bold rounded-full">
                      DEAL
                    </span>
                    {special.isElectric && (
                      <span className="px-2 py-1 bg-green-600 text-white text-xs font-bold rounded-full flex items-center gap-1">
                        <Zap className="w-3 h-3" /> EV
                      </span>
                    )}
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">{special.dealer}</p>
                  <h3 className="font-bold text-gray-900 dark:text-white mb-2 group-hover:text-orange-600 transition line-clamp-2">
                    {special.title}
                  </h3>
                  <div className="flex items-baseline gap-2 mb-3">
                    <span className="text-xl font-bold text-orange-600">{special.price}</span>
                    <span className="text-sm text-gray-500">or {special.monthlyPayment}/pm</span>
                  </div>
                  <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
                    <span className="flex items-center gap-1">
                      <MapPin className="w-3 h-3" />
                      {special.location}
                    </span>
                    <span className="flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      Until {special.validUntil}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}

        {filteredSpecials.length === 0 && (
          <div className="text-center py-12">
            <Tag className="w-16 h-16 text-gray-300 dark:text-gray-600 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">No specials found for this brand.</p>
          </div>
        )}
      </section>

      {/* Info Section */}
      <section className="container pb-12">
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-8 text-white">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-2xl font-bold mb-4">Don't Miss Out on These Deals!</h2>
              <p className="text-gray-300 mb-6">
                Car specials change regularly. Subscribe to our newsletter to get notified when new deals become available.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-orange-600 text-white rounded-lg font-semibold hover:bg-orange-700 transition"
                >
                  <Car className="w-5 h-5" />
                  Search All Cars
                </Link>
                <Link
                  to="/help-me-find"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 text-white rounded-lg font-semibold hover:bg-white/20 transition"
                >
                  Help Me Find
                  <ChevronRight className="w-5 h-5" />
                </Link>
              </div>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center gap-4 bg-white/10 rounded-xl p-6">
                <div className="text-center">
                  <p className="text-4xl font-bold text-orange-400">{specials.length}+</p>
                  <p className="text-sm text-gray-300">Active Deals</p>
                </div>
                <div className="w-px h-12 bg-white/20"></div>
                <div className="text-center">
                  <p className="text-4xl font-bold text-green-400">{brands.length - 1}</p>
                  <p className="text-sm text-gray-300">Brands</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Specials;
